export const loadCartFromLocalStorage = () => {
    try {
        const serializedState = localStorage.getItem("cartState");
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (e) {
        console.error("Could not load cart from localStorage", e);
        return undefined;
    }
};

export const saveCartToLocalStorage = (state: any) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem("cartState", serializedState);
    } catch (e) {
        console.error("Could not save cart to localStorage", e);
    }
};
